import { FC, PropsWithChildren, ReactElement } from 'react'

import './TableHead.scss'

interface TableHeadProps extends PropsWithChildren {
    className?: string;
}

const TableHead: FC<TableHeadProps> = ({
    className = '',
    children,
}): ReactElement => (
    <thead className={`table-head ${className}`}>
        {children}
    </thead>
)

export default TableHead
